import * as yup from "yup";
import { MultiAddModel, MultiAddSchema } from "../generic";

export interface AbstractTypePlacementData extends MultiAddModel {
    placementId: number | null;
    confirmationEmailText: string | null;
    displayName: string | null;
    id: number;
    invitationEmailText: string | null;
    isNew: boolean;
    sessionDuration: number | null;
}

export const AbstractTypePlacementSchema = yup.object<AbstractTypePlacementData>().shape({
    ...MultiAddSchema,
    placementId: yup.number().nullable(true).label("Placement").when(["isDeleted"], (isDeleted: boolean) => {
        const schema = yup.number().nullable(true).label("Placement");
        return isDeleted
            ? schema
            : schema.required();
    }),
    confirmationEmailText: yup.string().nullable(true).max(2000).label("Confirmation email info"),
    displayName: yup.string().nullable(true).label("Display name").when(["isDeleted"], (isDeleted: boolean) => {
        const schema = yup.string().nullable(true).label("Display name");
        return isDeleted
            ? schema
            : schema.max(50);
    }),
    id: yup.number().required().label("Type placement ID"),
    invitationEmailText: yup.string().nullable(true).max(2000).label("Acceptance email info"),
    isNew: yup.bool(),
    sessionDuration: yup.number().nullable(true).min(1).label("Session duration"),
});

export const DefaultAbstractTypePlacement: AbstractTypePlacementData = {
    confirmationEmailText: null,
    displayName: null,
    id: 0,
    index: 0,
    invitationEmailText: null,
    isDeleted: false,
    isNew: true,
    placementId: null,
    sessionDuration: null,
};



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/AbstractTypePlacement.ts